import React from "react";

// COMPONENTS
import TextField from "@components/TextField/TextField";

// HELPERS
import { localeNumber, parseLocaleNumber } from "@helpers/utils";


export default class NumberField extends React.PureComponent {
    render() {
        const { props } = this;
        const { name, unit = "", value, customInputFormatter } = props;

        const valueClean = _cleanValue.call(this, value);
        const valueLocale = _localeValue.call(this, value);

        const inputHiddenValue = (valueLocale || (!isNaN(valueLocale) && valueLocale === 0)) ? valueLocale + unit : "";
        
        return (
            <div className="Cob-NumberField">
                <TextField
                    className="Cob-NumberField-TextField"
                    validation={ this._validation }
                    { ...props }
                    type={ customInputFormatter ? "text" : "number" }
                    value={ valueClean }
                    // name={ undefined }
                    unit={ undefined }
                />
                { !!unit && <div className="Cob-NumberField-unit">{ unit.trim() }</div> }
                { name && <input type="hidden" name={ name } value={ inputHiddenValue } /> }
            </div>
        );
    }

    // Internal methods
    _validation = (value) => (!isNaN(value) && value.length > 0)
}


// PRIVATE FUNCTIONS
function _cleanValue(value) {
    const { delimiter1, delimiter2, customInputFormatter } = this.props;
    if(customInputFormatter) {
        return customInputFormatter(value);
    } else {
        if(typeof value === "number") return (Math.round(value * 10000) / 10000).toString();
        return value ? (!isNaN(value) ? value : parseLocaleNumber(value, delimiter1, delimiter2, true)) : "";
    }
}

function _localeValue(value) {
    const { decimals, delimiter1, delimiter2, customInputFormatter } = this.props;
    if(customInputFormatter) {
        return customInputFormatter(value);
    } else {
        return value ? localeNumber(
            !isNaN(value) ? value : parseLocaleNumber(value, delimiter1, delimiter2),
            decimals, delimiter1, delimiter2
        ) : "";
    }
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/NumberField/NumberField.js